exports.f = require('./_wks');


//////////////////
// WEBPACK FOOTER
// ./~/.npminstall/core-js/2.4.1/core-js/library/modules/_wks-ext.js
// module id = 109
// module chunks = 0